import PropTypes from 'prop-types';
import React from 'react';
import { attemptStateTypes } from 'containers/app/helpers/attemptStateTypes';
import {
  BlankSlot,
  CurrentSlot,
  SubmittedSlot
} from './styles/StyledComponents';

const ProgressSlot = ({
  currentSection,
  currentSlotIndex,
  attemptState,
  index,
  formikProps,
  setSlot
}) => {
  const handleClick = async index => {
    // Record the navigation target BEFORE submitting. Formik invokes onSubmit
    // before submitForm() resolves, and onSubmit is what reads this target, so
    // setting it afterwards left it holding the value from the pre-click
    // render. On the first click of a section that is the `null` seed of
    // SectionClickable's newSlot, which crashed moveToNextSlot and surfaced to
    // the taker as a fabricated 500 error page (UB-4212).
    // This setSlot is flushed when the handler suspends at the await, so
    // onSubmit sees it. Do not move it back below the await.
    setSlot(index);
    try {
      await formikProps.submitForm();
    } catch (error) {
      console.error('Error submitting slot before navigation:', error);
    }
  };

  const id = `pill-${index}`;

  const renderProgressSlot = () => {
    const sectionStatus = currentSection.attempt_state;
    if (
      currentSlotIndex === index &&
      sectionStatus === attemptStateTypes.IN_PROGRESS
    ) {
      return <CurrentSlot id={id} />;
    } else if (
      attemptState === attemptStateTypes.PENDING ||
      attemptState === attemptStateTypes.IN_PROGRESS
    ) {
      return <BlankSlot id={id} onClick={() => handleClick(index)}></BlankSlot>;
    } else if (
      attemptState === attemptStateTypes.SUBMITTED ||
      attemptState === attemptStateTypes.COMPLETE
    ) {
      return (
        <SubmittedSlot
          id={id}
          onClick={() => handleClick(index)}
        ></SubmittedSlot>
      );
    }
  };

  return renderProgressSlot();
};

ProgressSlot.propTypes = {
  currentSection: PropTypes.object.isRequired,
  currentSlotIndex: PropTypes.number.isRequired,
  attemptState: PropTypes.oneOf([
    'PENDING',
    'IN_PROGRESS',
    'SUBMITTED',
    'COMPLETE'
  ]),
  index: PropTypes.number.isRequired,
  formikProps: PropTypes.object,
  setSlot: PropTypes.func
};

export default ProgressSlot;
